import { render, staticRenderFns } from "./ClientsMovements.vue?vue&type=template&id=315e5c08"
import script from "./ClientsMovements.vue?vue&type=script&lang=js"
export * from "./ClientsMovements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports